import { useState, useEffect } from "react";
import addMinutes from "date-fns/addMinutes";
import getTime from "date-fns/getTime";
import parseISO from "date-fns/parseISO";
import minutesToSeconds from "date-fns/minutesToSeconds";
import isPast from "date-fns/isPast";
import { ConfirmedAppointment } from "../AppointmentConfirmedScreen/parseConfirmedAppointment";
import useSystemConfig from "../../../hooks/useSystemConfig";

const useUpsellTimer = (params: {
  appointmentId?: string;
  appointmentData: ConfirmedAppointment | null;
}) => {
  const { appointmentData } = params;
  const systemConfig = useSystemConfig();

  const [expiresAt, setExpiresAt] = useState<number | null>(null);

  useEffect(() => {
    if (!appointmentData?.confirmedAt || !systemConfig?.data) return;

    const upsellExpiresAt = addMinutes(
      parseISO(appointmentData.confirmedAt.toString()),
      systemConfig.data.upsellDurationMinutes,
    );

    setExpiresAt(getTime(upsellExpiresAt));
  }, [appointmentData, systemConfig.data]);

  useEffect(() => {
    if (expiresAt === null) return () => {};

    const interval = setInterval(() => {
      if (isPast(expiresAt)) {
        setExpiresAt(null);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [expiresAt]);

  if (
    !appointmentData ||
    expiresAt === null ||
    !systemConfig.data?.upsellDurationMinutes
  ) {
    return null;
  }

  const durationInSeconds = minutesToSeconds(
    systemConfig.data?.upsellDurationMinutes,
  );

  return {
    expiresAt,
    durationInSeconds,
  };
};

export default useUpsellTimer;
